import React from 'react';
import ReactJson from 'react-json-view';
import constate from 'constate';
import { useSearchParams } from 'react-router-dom';

import Card from '~/components/Card';
import If from '~/components/If';

import { ScreenWidget } from '~/widgets';
import appWithSettings from '~/hocs/appSettings';
import withProvider from '~/hocs/withProvider';

import { useProviderFactory } from '~/hooks/useProviderFactory';

import initialObj from './INITIAL_OBJ.json';

const useScenario = () => useProviderFactory();

const [ScenarioProvider, useScenarioState, useScenarioEffects] = constate(
  useScenario,
  (value) => value.state,
  (value) => value.effects,
);

export const ScenarioPage = () => {
  const [searchParams] = useSearchParams();

  const { store } = useScenarioState();
  const { setValue } = useScenarioEffects();

  const hasStore = !!searchParams.get('store');

  return (
    <>
      <ScreenWidget
        widgetFieldProps={{
          currentStore: store,
          sendValue: (payload) => setValue(payload),
        }}
        data={initialObj as any}
      />

      <If condition={window.location.origin.includes('localhost') || hasStore}>
        <Card className="mb-3" title="Store" defaultOpened={false}>
          <ReactJson src={store} />
        </Card>
      </If>
    </>
  );
};

export const Scenario = appWithSettings({
  title: 'Scenario Reports',
  description: '',
})(withProvider(ScenarioProvider)(ScenarioPage));
